
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-verification",
      function () {
        return require("private-next-pages/email-verification/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-verification"])
      });
    }
  